import { render, staticRenderFns } from "./ChatConfigurationTabs.vue?vue&type=template&id=c8415d24&lang=pug&"
import script from "./ChatConfigurationTabs.vue?vue&type=script&lang=js&"
export * from "./ChatConfigurationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatConfigurationTabs.vue"
export default component.exports